import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth';

// Admin-only route guard (P4 Section 2.5). Assumes it is nested inside
// RequireAuth, so by the time status is settled we have a user. A non-admin is
// bounced to the hearing screen rather than shown a forbidden page.
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  if (status === 'loading') {
    return <div className="min-h-screen bg-stone-950" />;
  }
  if (status === 'unauthed') {
    return <Navigate to="/login" replace />;
  }
  if (user?.role !== 'ADMIN') {
    return <Navigate to="/hearing" replace />;
  }
  return <>{children}</>;
}
